module.exports = __webpack_public_path__ + "img/ru.911c03c2.svg";